import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import dayjs from "@/lib/day";
import LogicaAPI from "./logicaapi";

var Terms = /*#__PURE__*/function (_LogicaAPI) {
  _inherits(Terms, _LogicaAPI);

  var _super = _createSuper(Terms);

  function Terms() {
    _classCallCheck(this, Terms);

    return _super.apply(this, arguments);
  }

  _createClass(Terms, [{
    key: "getTerm",
    value: function () {
      var _getTerm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, withAgreement) {
        var _this$context, _this$context$req;

        var params;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  with_current_revision: true,
                  ts: dayjs().unix()
                };

                if (withAgreement && (_this$context = this.context) !== null && _this$context !== void 0 && (_this$context$req = _this$context.req) !== null && _this$context$req !== void 0 && _this$context$req.userToken) {
                  params["with_agreement"] = true;
                }

                _context.next = 4;
                return this.get("/api/v1/terms/".concat(key), {
                  params: params
                });

              case 4:
                return _context.abrupt("return", _context.sent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTerm(_x, _x2) {
        return _getTerm.apply(this, arguments);
      }

      return getTerm;
    }()
  }, {
    key: "agree",
    value: function agree(key) {
      var params = {
        revision_unique_key: key
      };
      return this.post("/api/v1/terms/agree", {
        body: params
      });
    }
  }]);

  return Terms;
}(LogicaAPI);

export default Terms;